import { useState } from "react";
import { Navigate } from "react-router-dom";
import Loader from "../../components/Loader";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import constantsValues from "../../constants/constantsValues";
import { MdContentCopy } from "react-icons/md";
import { IoCheckmarkDone } from "react-icons/io5";

export default function Claimer() {
  const location = useLocation();
  const navigate = useNavigate();
  const { contractAddress } = useParams();
  const data = location?.state;

  const [isLoading, setLoading] = useState(false);
  const [tokeuriCopied, setTokenUriCopied] = useState(false);

  const collapseAddress = (address) => {
    if (!address || address.length <= 44) return address;
    return `${address.substring(0, 24)}.....${address.substring(address.length - 20)}`;
  };

  if (!data) {
    return <Navigate to="/" />;
  }

  return (
    <>
      {isLoading ? (
        <div className="loader-position">
          <Loader />
        </div>
      ) : (
        <>
          <main className="nftDetails">
            <div className="nftDetails-container">
              <div className="container-left">
                <span className="image-box">
                  <img src={data.imageURL} alt="claimer-img" height="100%" width="100%" />
                </span>
                <div className="details-container">
                  <div className="description-header">
                    <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M1.53755 0.200195C1.20934 0.200195 0.89458 0.326623 0.662504 0.551667C0.430428 0.776711 0.300049 1.08194 0.300049 1.4002C0.300049 1.71846 0.430428 2.02368 0.662504 2.24872C0.89458 2.47377 1.20934 2.6002 1.53755 2.6002H25.4626C25.7908 2.6002 26.1055 2.47377 26.3376 2.24872C26.5697 2.02368 26.7001 1.71846 26.7001 1.4002C26.7001 1.08194 26.5697 0.776711 26.3376 0.551667C26.1055 0.326623 25.7908 0.200195 25.4626 0.200195H1.53755ZM1.53755 5.0002C1.20934 5.0002 0.89458 5.12662 0.662504 5.35167C0.430428 5.57671 0.300049 5.88194 0.300049 6.2002C0.300049 6.51846 0.430428 6.82368 0.662504 7.04872C0.89458 7.27377 1.20934 7.4002 1.53755 7.4002H25.4626C25.7908 7.4002 26.1055 7.27377 26.3376 7.04872C26.5697 6.82368 26.7001 6.51846 26.7001 6.2002C26.7001 5.88194 26.5697 5.57671 26.3376 5.35167C26.1055 5.12662 25.7908 5.0002 25.4626 5.0002H1.53755ZM0.300049 11.0002C0.300049 10.6819 0.430428 10.3767 0.662504 10.1517C0.89458 9.92663 1.20934 9.8002 1.53755 9.8002H25.4626C25.7908 9.8002 26.1055 9.92663 26.3376 10.1517C26.5697 10.3767 26.7001 10.6819 26.7001 11.0002C26.7001 11.3185 26.5697 11.6237 26.3376 11.8487C26.1055 12.0738 25.7908 12.2002 25.4626 12.2002H1.53755C1.20934 12.2002 0.89458 12.0738 0.662504 11.8487C0.430428 11.6237 0.300049 11.3185 0.300049 11.0002ZM1.53755 14.6002C1.20934 14.6002 0.89458 14.7266 0.662504 14.9517C0.430428 15.1767 0.300049 15.4819 0.300049 15.8002C0.300049 16.1185 0.430428 16.4237 0.662504 16.6487C0.89458 16.8738 1.20934 17.0002 1.53755 17.0002H17.2125C17.5408 17.0002 17.8555 16.8738 18.0876 16.6487C18.3197 16.4237 18.4501 16.1185 18.4501 15.8002C18.4501 15.4819 18.3197 15.1767 18.0876 14.9517C17.8555 14.7266 17.5408 14.6002 17.2125 14.6002H1.53755Z"
                        fill="white"
                      />
                    </svg>
                    Description
                  </div>
                  <p className="content desc">
                    {data
                      ? data.description
                      : "Lorem ipsum dolor sit amet consectetur adipisicing elit. Iure et maxime ipsa. Ipsum atque, provident laboriosam pariatur voluptates at, nesciunt fugiat reiciendis id fuga assumenda corporis nobis veniam nostrum iure?"}
                  </p>
                  <p className="content">CREATED BY</p>
                  <p className="content created-name">{data.createdBy}</p>
                </div>
              </div>
              <div style={{ width: "100%" }} className="container-right">
                <div className="address-icon">
                  <span className="icon-container">
                    <svg width="51" height="51" viewBox="0 0 51 51" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g filter="url(#filter0_i_2101_4)">
                        <circle cx="25.5" cy="25.5" r="24" stroke="white" stroke-width="3" />
                      </g>
                      <g filter="url(#filter1_i_2101_4)">
                        <ellipse cx="25.5" cy="25.5" rx="4.5" ry="25.5" fill="white" />
                      </g>
                      <g filter="url(#filter2_i_2101_4)">
                        <ellipse
                          cx="25.5"
                          cy="25.5"
                          rx="4.5"
                          ry="25.5"
                          transform="rotate(-90 25.5 25.5)"
                          fill="white"
                        />
                      </g>
                      <g filter="url(#filter3_i_2101_4)">
                        <ellipse
                          cx="25.5001"
                          cy="25.5"
                          rx="4.5"
                          ry="25.5"
                          transform="rotate(-45 25.5001 25.5)"
                          fill="white"
                        />
                      </g>
                      <g filter="url(#filter4_i_2101_4)">
                        <ellipse
                          cx="25.5001"
                          cy="25.4999"
                          rx="4.5"
                          ry="25.5"
                          transform="rotate(-135 25.5001 25.4999)"
                          fill="white"
                        />
                      </g>
                      <defs>
                        <filter
                          id="filter0_i_2101_4"
                          x="0"
                          y="0"
                          width="51"
                          height="55"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="5.5" />
                          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2101_4" />
                        </filter>
                        <filter
                          id="filter1_i_2101_4"
                          x="21"
                          y="0"
                          width="9"
                          height="55"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="5.5" />
                          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2101_4" />
                        </filter>
                        <filter
                          id="filter2_i_2101_4"
                          x="0"
                          y="21"
                          width="51"
                          height="13"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="5.5" />
                          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2101_4" />
                        </filter>
                        <filter
                          id="filter3_i_2101_4"
                          x="7.18726"
                          y="7.18713"
                          width="36.6257"
                          height="40.6257"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="5.5" />
                          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2101_4" />
                        </filter>
                        <filter
                          id="filter4_i_2101_4"
                          x="7.18726"
                          y="7.18701"
                          width="36.6257"
                          height="40.6259"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood flood-opacity="0" result="BackgroundImageFix" />
                          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="5.5" />
                          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
                          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_2101_4" />
                        </filter>
                      </defs>
                    </svg>
                  </span>
                  <div>
                    <a
                      href={constantsValues[data?.contractData?.chainId]?.blockExplorer + contractAddress}
                      target="_blank"
                    >
                      <p className="address">{`${contractAddress.substring(0, 5)}....${contractAddress.substring(
                        contractAddress.length - 5
                      )}`}</p>
                    </a>
                  </div>
                </div>
                <p className="title-header">Title</p>
                <h4 className="title-name">{data.name}</h4>
                <p style={{ display: "flex", alignItems: "center" }} className="title-header">
                  Token URI
                  {!tokeuriCopied && (
                    <MdContentCopy
                      style={{ marginLeft: "0.5rem" }}
                      className="token-uri-copy"
                      onClick={(event) => {
                        navigator.clipboard
                          .writeText(data.tokenURI)
                          .then(() => {
                            setTokenUriCopied(true);
                            setTimeout(() => {
                              setTokenUriCopied(false);
                            }, 2000);
                          })
                          .catch(console.error);
                      }}
                    />
                  )}
                  {tokeuriCopied && <IoCheckmarkDone style={{ marginLeft: "0.5rem" }} className="token-uri-copy" />}
                </p>
                <h4
                  style={{
                    fontSize: "1.2rem",
                    fontWeight: 500,
                  }}
                  className="title-name"
                >
                  <a
                    href={`https://ipfs.io/ipfs/${data.tokenURI?.split("ipfs://")[1]}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="token-uri-link"
                  >
                    {collapseAddress(data.tokenURI)}
                  </a>
                </h4>
                <div className="logos">
                  {constantsValues[data?.contractData?.chainId]?.openSeaNFTDetails ? (
                    <a
                      href={`${constantsValues[data?.contractData?.chainId]?.openSeaNFTDetails}${contractAddress}/${
                        data?.token
                      }`}
                      target={"/blank"}
                    >
                      <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M11.5 0C5.15008 0 0 5.15008 0 11.5C0 17.8499 5.15008 23 11.5 23C17.8499 23 23 17.8499 23 11.5C23 5.15008 17.8528 0 11.5 0ZM5.67333 11.8862L5.72221 11.8086L8.71508 7.12808C8.72511 7.1127 8.73908 7.10029 8.75554 7.09214C8.772 7.084 8.79034 7.08043 8.80865 7.0818C8.82697 7.08317 8.84457 7.08944 8.85964 7.09994C8.8747 7.11044 8.88667 7.12479 8.89429 7.1415C9.39262 8.26179 9.82579 9.65521 9.62263 10.5225C9.53829 10.879 9.30158 11.362 9.03421 11.8086C8.99991 11.8739 8.96249 11.9376 8.92208 11.9993C8.91241 12.0131 8.89946 12.0242 8.8844 12.0317C8.86935 12.0393 8.85266 12.0429 8.83583 12.0424H5.76246C5.74411 12.0427 5.72604 12.038 5.71014 12.0288C5.69425 12.0197 5.68113 12.0064 5.67219 11.9904C5.66325 11.9743 5.65881 11.9562 5.65935 11.9379C5.65989 11.9195 5.66538 11.9017 5.67525 11.8862H5.67333ZM19.0076 13.4962C19.0078 13.5167 19.002 13.5368 18.991 13.554C18.9799 13.5712 18.964 13.5847 18.9453 13.593C18.7124 13.6917 17.9199 14.0578 17.5902 14.5149C16.7488 15.686 16.1067 17.3612 14.6692 17.3612H8.67579C8.16976 17.3604 7.66883 17.2599 7.20164 17.0655C6.73445 16.8711 6.31016 16.5865 5.95301 16.228C5.59585 15.8695 5.31284 15.4442 5.12015 14.9762C4.92746 14.5083 4.82887 14.007 4.83 13.501V13.432C4.83 13.3764 4.876 13.3304 4.9335 13.3304H8.27329C8.34037 13.3304 8.38829 13.3908 8.3835 13.4569C8.35858 13.6735 8.39979 13.8968 8.50329 14.099C8.70071 14.5015 9.11279 14.7526 9.5565 14.7526H11.2106V13.4617H9.57375C9.55457 13.4615 9.53581 13.4561 9.51949 13.446C9.50317 13.4359 9.4899 13.4216 9.48113 13.4045C9.47235 13.3875 9.4684 13.3683 9.46969 13.3492C9.47098 13.3301 9.47747 13.3116 9.48846 13.2959L9.54883 13.2097C9.70217 12.9883 9.92354 12.6481 10.144 12.259C10.2935 11.9964 10.4391 11.7166 10.556 11.4348C10.579 11.385 10.5972 11.3323 10.6183 11.2815C10.65 11.1914 10.6825 11.1071 10.7055 11.0237C10.7281 10.953 10.7489 10.8818 10.7678 10.81C10.8225 10.5704 10.8455 10.3174 10.8455 10.0558C10.8455 9.95229 10.8416 9.844 10.832 9.74242C10.8273 9.63029 10.8129 9.51721 10.7995 9.40508C10.7887 9.30476 10.7734 9.20499 10.7535 9.10608C10.7277 8.95548 10.6963 8.80588 10.6595 8.65758L10.6461 8.60008C10.6174 8.49658 10.5925 8.39883 10.5599 8.29629C10.4686 7.98139 10.3637 7.6706 10.2455 7.36479C10.2044 7.24976 10.159 7.13628 10.1095 7.02458C10.0405 6.854 9.96954 6.69971 9.90533 6.555C9.87339 6.493 9.84334 6.43004 9.81525 6.36621C9.78408 6.29734 9.75117 6.22928 9.71654 6.16208C9.69354 6.11129 9.66575 6.06242 9.64754 6.01642L9.44533 5.64458C9.41754 5.59379 9.46354 5.5315 9.51912 5.54779L10.7841 5.88992H10.7937L10.9595 5.93783L11.1435 5.98958L11.2106 6.00779V5.25742C11.2106 4.89421 11.5 4.6 11.8613 4.6C11.9466 4.59977 12.0311 4.6168 12.1096 4.65007C12.1882 4.68334 12.2592 4.73215 12.3184 4.79358C12.4408 4.917 12.5096 5.08363 12.5101 5.25742V6.37292L12.6452 6.41029C12.6548 6.41508 12.6663 6.41987 12.6749 6.42658C12.7075 6.44958 12.7554 6.486 12.8158 6.532C12.8637 6.56842 12.9145 6.61442 12.9739 6.66329C13.1632 6.81747 13.3466 6.97858 13.524 7.14629C13.7291 7.337 13.9591 7.56029 14.1795 7.8085C14.2418 7.87942 14.3012 7.94842 14.3635 8.02508C14.4229 8.10079 14.49 8.17458 14.5456 8.24742C14.6213 8.34708 14.6989 8.45058 14.7708 8.55792C14.8024 8.60871 14.8417 8.66142 14.8714 8.71221C14.9634 8.84829 15.042 8.98821 15.1177 9.12908C15.1503 9.19329 15.1819 9.26421 15.2097 9.33321C15.295 9.522 15.3621 9.71271 15.4033 9.90629C15.4169 9.94738 15.4262 9.98977 15.4311 10.0328V10.0424C15.4445 10.097 15.4493 10.1574 15.4541 10.2187C15.4811 10.502 15.4464 10.7877 15.3525 11.0563C15.3228 11.1368 15.295 11.2192 15.2586 11.2997C15.1867 11.4626 15.1043 11.6284 15.0056 11.7808C14.973 11.8383 14.9337 11.8977 14.8973 11.9552C14.8561 12.0156 14.812 12.0731 14.7756 12.1277C14.7229 12.2003 14.6676 12.2709 14.6098 12.3395C14.559 12.4085 14.5082 12.4775 14.4507 12.5398C14.3731 12.6337 14.2974 12.7219 14.2159 12.8062C14.1699 12.8618 14.1201 12.9193 14.0664 12.9691C14.0166 13.0266 13.9629 13.0774 13.9169 13.1234C13.8364 13.2039 13.7732 13.2643 13.7176 13.317L13.5863 13.4339C13.568 13.4523 13.5432 13.4626 13.5173 13.4627H12.5101V14.7526H13.777C14.0597 14.7526 14.329 14.6529 14.5475 14.467C14.6213 14.4028 14.9452 14.122 15.3295 13.6984C15.342 13.684 15.3588 13.6739 15.3774 13.6697L18.8753 12.6567C18.8907 12.6523 18.9069 12.6514 18.9226 12.6543C18.9383 12.6572 18.9532 12.6636 18.966 12.6732C18.9788 12.6828 18.9892 12.6952 18.9964 12.7094C19.0037 12.7237 19.0075 12.7394 19.0076 12.7554V13.4962Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  ) : null}
                  {constantsValues[data?.contractData?.chainId]?.raribleNFTDetails ? (
                    <a
                      href={`${constantsValues[data?.contractData?.chainId]?.raribleNFTDetails}${contractAddress}:${
                        data?.token
                      }?tab=overview`}
                      target={"/blank"}
                    >
                      <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M4.60001 1.00253e-05C3.99557 -0.00125317 3.39684 0.116867 2.83817 0.347591C2.2795 0.578316 1.7719 0.917101 1.3445 1.3445C0.917101 1.7719 0.578316 2.2795 0.347591 2.83817C0.116867 3.39684 -0.00125317 3.99557 1.00253e-05 4.60001V18.4C-0.00125317 19.0044 0.116867 19.6032 0.347591 20.1618C0.578316 20.7205 0.917101 21.2281 1.3445 21.6555C1.7719 22.0829 2.2795 22.4217 2.83817 22.6524C3.39684 22.8832 3.99557 23.0013 4.60001 23H18.4C19.0044 23.0013 19.6032 22.8832 20.1618 22.6524C20.7205 22.4217 21.2281 22.0829 21.6555 21.6555C22.0829 21.2281 22.4217 20.7205 22.6524 20.1618C22.8832 19.6032 23.0013 19.0044 23 18.4V4.60001C23.0013 3.99557 22.8832 3.39684 22.6524 2.83817C22.4217 2.2795 22.0829 1.7719 21.6555 1.3445C21.2281 0.917101 20.7205 0.578316 20.1618 0.347591C19.6032 0.116867 19.0044 -0.00125317 18.4 1.00253e-05H4.60001ZM5.86501 7.36001H13.7253C15.6994 7.36001 17.2385 7.78168 17.2385 9.59676C17.2385 10.6864 16.5955 11.2278 15.871 11.4157C16.7373 11.6725 17.364 12.374 17.364 13.4857V15.5279H14.0568V13.5892C14.0568 12.995 13.7023 12.7554 13.0985 12.7554H9.17318V15.5279H5.86501V7.36001ZM9.17318 9.75584V10.5551H13.1551C13.5882 10.5551 13.8508 10.4976 13.8508 10.1564C13.8508 9.81334 13.5882 9.75584 13.1551 9.75584H9.17318Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  ) : null}
                  {data?.contractData?.chainId === "0x13881" ? (
                    <a
                      href={`https://marketplace-nextjs-jijvnx4ps-lync-world.vercel.app/nft/${contractAddress}/${data?.token}`}
                      target={"/blank"}
                    >
                      <svg width="23" height="23" viewBox="0 0 323 204" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M198.105 112.734C192.772 161.253 151.71 198.997 101.846 198.997C48.3594 198.997 5 155.569 5 101.999C5 48.4277 48.3594 5 101.846 5C127.403 5 150.649 14.9155 167.956 31.1152L138.641 31.1152V39.2604C127.85 32.8976 115.273 29.248 101.845 29.248C61.7305 29.248 29.2109 61.8188 29.2109 101.997C29.2109 142.175 61.7305 174.746 101.845 174.746C138.318 174.746 168.512 147.821 173.694 112.734H198.105Z"
                          fill="white"
                        />
                        <path
                          d="M198.105 112.734L203.075 113.28L203.685 107.734H198.105V112.734ZM167.956 31.1152V36.1152H180.615L171.373 27.4648L167.956 31.1152ZM138.641 31.1152V26.1152H133.641V31.1152H138.641ZM138.641 39.2604L136.102 43.5675L143.641 48.0131V39.2604H138.641ZM173.694 112.734V107.734H169.378L168.748 112.003L173.694 112.734ZM101.846 203.997C154.294 203.997 197.467 164.3 203.075 113.28L193.135 112.187C188.077 158.206 149.125 193.997 101.846 193.997V203.997ZM5.96046e-07 101.999C5.96046e-07 158.323 45.5905 203.997 101.846 203.997V193.997C51.1282 193.997 10 152.815 10 101.999H5.96046e-07ZM101.846 5.96046e-07C45.5905 5.96046e-07 5.96046e-07 45.6737 5.96046e-07 101.999H10C10 51.1817 51.1282 10 101.846 10V5.96046e-07ZM171.373 27.4648C153.177 10.4331 128.723 5.96046e-07 101.846 5.96046e-07V10C126.084 10 148.121 19.3979 164.539 34.7657L171.373 27.4648ZM138.641 36.1152H167.956V26.1152L138.641 26.1152V36.1152ZM143.641 39.2604V31.1152L133.641 31.1152V39.2604H143.641ZM141.181 34.9534C129.642 28.1495 116.191 24.248 101.845 24.248V34.248C114.356 34.248 126.059 37.6457 136.102 43.5675L141.181 34.9534ZM101.845 24.248C58.9616 24.248 24.2109 59.0649 24.2109 101.997H34.2109C34.2109 64.5728 64.4993 34.248 101.845 34.248V24.248ZM24.2109 101.997C24.2109 144.929 58.9616 179.746 101.845 179.746V169.746C64.4993 169.746 34.2109 139.421 34.2109 101.997H24.2109ZM101.845 179.746C140.84 179.746 173.102 150.962 178.641 113.464L168.748 112.003C163.922 144.68 135.797 169.746 101.845 169.746V179.746ZM198.105 107.734H173.694V117.734H198.105V107.734Z"
                          fill="white"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M167.979 183.217C183.201 193.196 201.398 198.998 220.949 198.998C274.436 198.998 317.795 155.57 317.795 101.999C317.795 48.4287 274.436 5.00091 220.949 5.00091C167.463 5.00091 124.103 48.4287 124.103 101.999C124.103 102.313 124.105 102.627 124.108 102.94H148.321C148.317 102.628 148.315 102.315 148.315 102.001C148.315 61.823 180.835 29.2522 220.95 29.2522C261.064 29.2522 293.584 61.823 293.584 102.001C293.584 142.179 261.064 174.75 220.95 174.75C200.06 174.75 181.23 165.918 167.979 151.778V183.217Z"
                          fill="white"
                        />
                        <path
                          d="M167.979 183.217H162.979V185.917L165.238 187.398L167.979 183.217ZM124.108 102.94L119.108 102.988L119.155 107.94H124.108V102.94ZM148.321 102.94V107.94L153.385 107.94L153.321 102.877L148.321 102.94ZM167.979 151.778L171.628 148.359L162.979 139.13V151.778H167.979ZM165.238 187.398C181.249 197.895 200.395 203.998 220.949 203.998V193.998C202.402 193.998 185.153 188.497 170.721 179.035L165.238 187.398ZM220.949 203.998C277.204 203.998 322.795 158.324 322.795 101.999H312.795C312.795 152.816 271.667 193.998 220.949 193.998V203.998ZM322.795 101.999C322.795 45.6747 277.204 0.000908732 220.949 0.000908732V10.0009C271.667 10.0009 312.795 51.1827 312.795 101.999H322.795ZM220.949 0.000908732C164.694 0.000908732 119.103 45.6747 119.103 101.999H129.103C129.103 51.1827 170.231 10.0009 220.949 10.0009V0.000908732ZM119.103 101.999C119.103 102.329 119.105 102.659 119.108 102.988L129.107 102.893C129.105 102.595 129.103 102.298 129.103 101.999H119.103ZM124.108 107.94H148.321V97.9402H124.108V107.94ZM143.315 102.001C143.315 102.336 143.317 102.67 143.322 103.003L153.321 102.877C153.317 102.585 153.315 102.293 153.315 102.001L143.315 102.001ZM220.95 24.2522C178.066 24.2522 143.315 59.069 143.315 102.001L153.315 102.001C153.315 64.577 183.604 34.2522 220.95 34.2522L220.95 24.2522ZM298.584 102.001C298.584 59.069 263.833 24.2522 220.95 24.2522L220.95 34.2522C258.296 34.2522 288.584 64.577 288.584 102.001H298.584ZM220.95 179.75C263.833 179.75 298.584 144.933 298.584 102.001H288.584C288.584 139.425 258.296 169.75 220.95 169.75V179.75ZM164.331 155.197C178.486 170.302 198.62 179.75 220.95 179.75V169.75C201.5 169.75 183.973 161.533 171.628 148.359L164.331 155.197ZM162.979 151.778V183.217H172.979V151.778H162.979Z"
                          fill="white"
                        />
                      </svg>
                    </a>
                  ) : null}
                </div>

                <button
                  onClick={() => {
                    navigate(`/contract/${contractAddress}`, {
                      state: {
                        contractAddress: data.contractData.contractAddress,
                        contractName: data.contractData.contractName,
                        category: data.contractData.category,
                        networkType: data.contractData.networkType,
                        contractType: data.contractData.contractType,
                        symbol: data.contractData.symbol,
                        chainId: data.contractData.chainId,
                        contractCreatedAt: data.contractData.contractCreatedAt,
                        isWhiteListUser: data.contractData.isWhiteListUser,
                        prv: true,
                      },
                    });
                  }}
                  className="go-backBtn"
                >
                  Go To Dashboard
                </button>
              </div>
            </div>
          </main>
        </>
      )}
    </>
  );
}
